<app-menu *ngIf="isLoggedIn"></app-menu>
<div class="app">
    <router-outlet></router-outlet>
</div>
<message-dialog></message-dialog>